import Vue from 'vue'
import Router from 'vue-router'
import Lobby from './views/lobby/index.vue'
import Tables from './views/tables/index.vue'
import Game from './views/game/index.vue'
import Auth from '@services/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Lobby,
    },
    {
      path: '/tables',
      name: 'tables',
      component: Tables,
    },
    {
      path: '/game',
      name: 'game',
      component: Game,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // Redirect to login if no userKey
  if (to.name === 'login') {
    if (!Auth.hasKey) {
      return next()
    }
    return next({ name: 'tables' })
  }

  // Only allow router access to table
  if (to.name === 'game' && from.name !== 'tables') {
    return next({ name: 'tables' })
  }

  try {
    await Auth.authenticate()
    return next()
  } catch (error) {
    return next({ name: 'login' })
  }
})

export default router
